(() => {
  if (customElements.get('shevee-random-recommendations')) return;

  class SheveeRandomRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-recs-track]');
      this.previous = this.querySelector('[data-recs-previous]');
      this.next = this.querySelector('[data-recs-next]');
      if (!this.dataset.ready) {
        const seen = new Set([this.dataset.currentProductId]);
        const pool = [...this.querySelector('[data-recs-pool]').content.children].filter((card) => {
          const id = card.dataset.recommendationId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        if (this.dataset.randomize !== 'false') {
          // Fisher-Yates: one shuffle per visit, never on swatch selection or resize.
          for (let index = pool.length - 1; index > 0; index--) {
            const target = Math.floor(Math.random() * (index + 1));
            [pool[index], pool[target]] = [pool[target], pool[index]];
          }
        }
        const count = Math.min(Number(this.dataset.limit) || 8, pool.length);
        // Move the parsed cards: cloning would drop Horizon's declarative
        // shadow roots and break the horizontal colour-swatch controls.
        this.track.replaceChildren(...pool.slice(0, count));
        this.dataset.ready = 'true';
        this.hidden = count === 0;
      }
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      const visible = Math.max(1, Math.round(this.track.clientWidth / step));
      this.track.scrollBy({
        left: direction * step * visible,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.previous.disabled = scrollLeft <= 2;
      this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
      const card = this.track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      const first = Math.round(scrollLeft / step) + 1;
      const last = Math.min(this.track.children.length, first + Math.round(clientWidth / step) - 1);
      this.querySelector('[data-recs-status]').textContent = `Recommendations ${first}–${last} of ${this.track.children.length}`;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('shevee-random-recommendations', SheveeRandomRecommendations);
})();
